export default {
  isLoadingList: false,

  points: [],
  pointsInitiallyLoaded: false,

  detailedLocations: null,
  locationDetailsLookup: {},

  filters: [],
  filterOptions: {},
  searchedLocation: null,
  otherSearchParams: [],

  pagination: {page: 1, perPage: 0, totalCount: 0, totalPages: 1},

  urlFilterKeys: [],

  additionalUrlKeysIncludedInItemPageUrls: [],
  additionalParamsIncludedInEventUrls: {},
  eventCreationAllowed: null,
  eventCreationRequiresSearchedLocation: false,
  forceCreateEventButtonHidden: false,
  groupCreationAllowed: null,
  searchStrategy: null
}
